<!-- same skin as the classic Auto Text popup (_auto-text-popup.scss) -->
<div class="t-popup popup-auto-text" style="display: block;">

    <div class="popup-close"></div>

    <div class="popup-frame">
        <div class="popup-body">
            <h2>Select Auto Text for {{ field?.Label }}</h2>

            <textarea [(ngModel)]="Text" dir="auto"></textarea>

            <div class="auto-text-list">
                <div class="auto-text-item" *ngFor="let a of field?.autoTexts">
                    <div class="auto-text-txt" dir="auto"
                        style="cursor: pointer; white-space: pre-wrap; width: 100%; display: block; box-sizing: border-box; padding: 0.5em;"
                        (click)="addText(a.Content)">{{ a.Content }}</div>
                </div>
                <div class="auto-text-empty" *ngIf="!field?.autoTexts?.length">
                 לא הוגדרו Auto Texts לאינפוט הזה
                </div>
            </div>

            <button type="button" class="auto-text-submit-button" (click)="save()">Update &amp; Close</button>
            <button type="button" class="popup-close-button" (click)="close()">Close Auto Text Popup</button>
        </div>
    </div>

</div>
